<template>
<div id="app">
        <transition name="fadeslide" mode="out-in">
            <div id="search" v-if="searchVisible">
                <div class="container">
                    <div class="row">
                        <div class="searchWrapper offset-md-2 col-md-8">
                                        <!-- Replace this text by content or custom field -->
                            <p>For a list of IBBA Member Business Brokers, select a geography and radius. You may also optionally select one or more Specialty Areas and/or whether the person has achieved the Certified Business Intermediary (CBI) designation.
                            </p>
                            <div class="row zip-search-container">
                                <div class="search-input col-md-8">
                                    <label for="zipSearchss" class="fabblabel">Find the Closest Broker (U.S. or International)</label>
                                    <input id="zipSearchss" type="text" v-model="zipSearch" @keyup="geolocateSearch();" placeholder="Search By City or Zip/Postal Code"/>
                                    <span class="searchDescription">For the most results, select the largest search radius.</span>
                                    <transition name="fade">
                                        <div class="zipAutocomplete" v-if="showZipAutoComplete">
                                            <transition-group name="fade" tag="div">
                                            <span @click="fillValue(suggestion.place_name, suggestion.id);" v-for="suggestion in suggestions" v-bind:key="suggestion.id" :id="suggestion.id" :data-value="suggestion.place_name">{{suggestion.place_name}}</span>
                                            </transition-group>
                                        </div>
                                    </transition>
                                </div>
                                <div class="col-md-4">
                                    <p>Distance</p>
                                    <div class="styledSelect">
                                        <select name="distance" v-model="distance" id="distance">
                                            <option value="25">25 Miles</option>   
                                            <option value="50">50 Miles</option>   
                                            <option value="100">100 Miles</option>
                                            <option value="150">150 Miles</option>
                                            <option value="200">200 Miles</option>
                                            <option value="250">250 Miles</option>
                                        </select>
                                        <svg class="selectArrow" width="10px" height="14px" viewBox="0 0 10 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="Artboard-Copy-5" transform="translate(-1336.000000, -393.000000)" fill="#000000" fill-rule="nonzero">
                                                    <g id="ui" transform="translate(1336.000000, 393.000000)">
                                                        <polygon id="Path" points="10 9.21999296 5 14 0 9.21999296 0.731204943 8.52023935 4.48506694 12.1175642 4.48506694 0 5.51493306 0 5.51493306 12.1175642 9.26879506 8.52023935"></polygon>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <span class="fabblabel">Specialty Areas</span>
                            <div class="specialtyFilter row">
                                <div :key="index" class="filter col-md-6" v-for="(filter, index) in filters">
                                    <input :id="filter[1]" type="checkbox" :name="filter[1]" :value="filter[1]" v-model="specialties" @change="trackSpecialtySelection(filter[0])">
                                    <label :for="filter[1]" v-html="filter[0]"></label>
                                </div>
                            </div>
                            <div class="cbiBlock">
                                <input type="checkbox" v-model="cbi"> Only Show Me Certified Business Intermediaries (CBI)
                            </div>
                            <button id="searchBrokers" @click="getBrokers()">Find Business Broker</button>
                        </div>
                        <label for="nameSearch" class="fabblabel">Search by Broker or Company Name</label>
                            <input @input="onChange" @focus="fillBrokers();" id="nameSearch" type="search" v-model="nameSearch" value="" placeholder="Enter Broker or Company Name"/>
                            <span v-if="autoCompleteMsg !== '' && showAutoComplete !== false" v-html="autoCompleteMsg" style="display:block; margin-top: 20px; text-align: center; color: #d65a45;"></span>

                            <div class="autocomplete" v-if="showAutoComplete">
                                <h3>Results for your Search</h3>
                                <transition-group name="fade" mode="out-in" class="row">
                                    <div :key="i" v-for="(result, i) in results" class="brokerNameWrapper">
                                        <a :href="result[6]" @click="triggerGTMbrokerSearch()" class="acInner">
                                            <b>{{result[1]}}</b><br>
                                            <small v-if="result[5]">{{result[5]}}</small><br v-if="result[5]">
                                            <small v-if="result[2]">{{result[2]}}</small><small v-if="result[3]">, {{result[3]}}</small><small v-if="result[4]">, {{result[4]}}</small>
                                        </a>
                                    </div>
                                </transition-group>
                            </div>
                    </div>
                </div>
            </div> <!--Search-->
            </transition>
            <transition name="fade">
                <div class="errorMessageBlocker" v-if="showErrorMessage">
                    <div class="errorMessageContainer">
                    <div class="closeError" v-on:click="showErrorMessage = false">
                        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Artboard-Copy-5" transform="translate(-267.000000, -616.000000)" fill="#000000" fill-rule="nonzero">
                                    <g id="close" transform="translate(267.000000, 616.000000)">
                                        <polygon id="Path" points="18 2.12108093 15.8789191 0 8.99997672 6.87889579 2.12108093 0 0 2.12108093 6.87889579 8.99997672 3.30769609e-16 15.8789191 2.12108093 18 8.99997672 11.1211042 15.8788725 18 17.9999534 15.8789191 11.1211042 8.99997672"></polygon>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <h3>We couldn't find any broker matching your search</h3>
                    <p>We apologize, but there are no IBBA member brokers that meet your search criteria.<br><br>
                    We suggest expanding your search geography, as many business intermediaries have a very large service area.<br><br>
                    If you need additional assistance, please contact our headquarters at <a href="tel:888-686-4222">888-686-IBBA</a>.</p>
                    </div>
                </div>
            </transition>

            <div class="mapWrapper container-fluid" v-if="showResults">
            <div class="row">
                <div id="listings" class="listings col-md-4" v-if="showList">
                    <div class="showFilters" v-on:click="searchVisible = true">
                    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.94033 6.00044C9.94033 6.65669 10.3703 7.17644 11.0005 7.53169C10.8859 7.88737 10.714 8.24262 10.5421 8.57075C9.82575 8.40669 9.25283 8.653 8.76608 9.11762C8.27933 9.58225 8.13588 10.1296 8.30775 10.8129C7.964 10.977 7.59138 11.1411 7.21921 11.2504C6.84658 10.6489 6.18796 10.2385 5.50046 10.2385C4.81296 10.2385 4.15388 10.6489 3.78171 11.2504C3.40908 11.1411 3.00804 10.977 2.66429 10.8129C2.83617 10.1291 2.72158 9.58225 2.23438 9.11762C1.74717 8.653 1.17425 8.54319 0.458333 8.70725C0.286458 8.37912 0.114583 7.99631 0 7.64062C0.630208 7.28494 1.06013 6.65625 1.06013 6C1.06013 5.34375 0.630208 4.824 0 4.46875C0.114583 4.11306 0.258042 3.75781 0.458333 3.42969C1.17471 3.59375 1.74763 3.34744 2.23438 2.88281C2.72113 2.41819 2.83617 1.87087 2.66429 1.1875C3.00804 1.02344 3.40908 0.859375 3.78171 0.75C4.15433 1.35156 4.81296 1.76194 5.50046 1.76194C6.18796 1.76194 6.84704 1.35156 7.21921 0.75C7.59183 0.859375 7.99288 1.02344 8.33663 1.1875C8.16475 1.87131 8.27934 2.41819 8.76654 2.88281C9.25375 3.34744 9.82667 3.59375 10.5426 3.42969C10.7145 3.75781 10.8863 4.1135 11.0009 4.46875C10.3707 4.82444 9.94079 5.34375 9.94079 6L9.94033 6.00044ZM5.5 8.68012C7.04688 8.68012 8.30729 7.477 8.30729 6.00044C8.30729 4.52387 7.04688 3.32075 5.5 3.32075C3.95313 3.32075 2.69271 4.52387 2.69271 6.00044C2.69271 7.477 3.95313 8.68012 5.5 8.68012Z" fill="#D65A45"/>
                    </svg> Modify Search Filters
                    </div>
                    <h5 v-if="resultsNumber > 0">{{resultsNumber}} Brokers Found</h5>
                    <transition-group name="fadeslide" mode="out-in">

                    <div :key="broker.id" class="broker-block cbi-block" v-for="broker in brokerList" v-if="broker.cbi" v-on:click="flyToPlace(broker.coords, broker)">
                        <h3>
                            {{broker.name}} 
                        </h3>
                        <div class="certs"><span class="cbiList" v-if="broker.cbi">CBI</span><span class="brokers__item--topCBI brokers__item--topMCBI" v-if="broker.master_cbi">MCBI</span><span class="mami" v-if="broker.mami">M</span></div>
                        <p><span v-if="broker.company">{{broker.company}}<br></span> 
                        <span v-if="broker.city && broker.state">{{broker.city}}, {{broker.state}}<br></span><a :href="broker.permalink" target="_blank">View Profile</a></p>
                        <p class="listDistance"><small class="viewOnMapLink" v-on:click="flyToPlace(broker.coords, broker)">View on Map</small></p>
                    </div>
                    
                    </transition-group>
                    
                    <transition-group name="fadeslide" mode="out-in">
                    <div :key="broker.id" class="broker-block" v-for="broker in brokerList" v-if="broker.cbi === false" v-on:click="flyToPlace(broker.coords, broker)">
                        <h3>
                            {{broker.name}} 
                        </h3>
                        <div class="certs"><span class="brokers__item--topCBI brokers__item--topMCBI" v-if="broker.master_cbi">MCBI</span><span class="mami" v-if="broker.mami">M</span></div>
                        <p><span v-if="broker.company">{{broker.company}}<br></span> 
                        <span v-if="broker.city && broker.state">{{broker.city}}, {{broker.state}}<br></span><a :href="broker.permalink" target="_blank">View Profile</a></p>
                        <p class="listDistance"><small class="viewOnMapLink" v-on:click="flyToPlace(broker.coords, broker)">View on Map</small></p>
                    </div>
                    </transition-group>
                </div>
                <div class="mapContainer col-md-8" v-if="showResults">
                    <div id="map" v-if="showResults"></div>
                    <div class="legend">
                        <div class="legendContainer">
                            <div class="half">
                                <span class="cbiList">CBI</span> <span class="description">Indicates this member holds the Certified Business Intermediary (CBI) credential.</span>
                            </div>
                            <div class="half">
                                <span class="mami">M</span> <span class="description">Indicates this member holds the Merger & Acquisition Master Intermediary (M&AMI) credential.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="expander container">
        <h6>Brokers By State</h6>
        <hr>
            <div class="statescontainer">
                <h5 v-if="states.length > 0">United States</h5>
                <hr>
                <div class="row">
                    <div class="state col-6 col-sm-4 col-md-3" v-for="state in states" v-if="state.count > 0">
                        <a :href="state.link">{{state.name}}</a>
                    </div>
                </div>
                <br><br>
                <h5 v-if="cstates.length > 0">Canada</h5>
                <hr>
                <div class="row">
                    <div class="state col-6 col-sm-4 col-md-3" v-for="state in cstates" v-if="state.count > 0">
                        <a :href="state.link">{{state.name}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="expander container">
        <h6>Brokers By Industry</h6>
        <hr>
            <div class="statescontainer">
                <div class="row">
                    <div class="state col-6 col-sm-4 col-md-3" v-for="taxo in taxos">
                        <a :href="taxo.link" v-html="taxo.name"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//declare map as global variable
const app = new Vue({
  el: '#app',
  data: {
      searchVisible : true,
      nameSearch : '',
      zipSearch: '',
      distance: '25',
      specialties: [],
      cbi: '',
      brokerLoader: false,
      filters: [],
      showResults: false,
      geoJson: [],
      showAutoComplete: false,
      autoCompleteMsg: '',
      showTitle: false,
      showZipAutoComplete: false,
      showError: false,
      suggestions: '',
      results: [],
      fullNames: [],
      showErrorMessage : '',
      cbi: '',
      map: '',
      brokerList: [],
      showList: false,
      states: [],
      cstates: [],
      taxos:[],
      alreadyFocused: false
  },
  watch: {
    nameSearch: function() {
      if (this.nameSearch === "") {
        this.showAutoComplete = false;
        this.results = [];
        this.autoCompleteMsg = '';
      }
    }
  },
  computed:{
      resultsNumber: function(){
        return this.brokerList.length;
      }
  },
  methods: {
      //Autocomplete for Broker Names
    // onChange() {
    //     this.showAutoComplete = true;
    //     this.autocomplete();
    // },
    async geolocateSearch(event) {
      this.suggestions = '';
      this.showZipAutoComplete = false;
      let address = this.zipSearch;
      if (address.length > 4) {
        const suggestionResponse = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/` + address + `.json?types=postcode,address,locality,neighborhood,place&language=en&limit=8&autocomplete=false&proximity=-74.70850,40.78375&access_token=pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2s2dG11bXhvMDB0eTNycWN0NWR6bGxmMiJ9.rAfZTp56zepoSSpMs0I8XQ`);
        const geoCoded = await suggestionResponse.json();
        // console.log(geoCoded);
        this.suggestions = geoCoded.features;
        this.showZipAutoComplete= true;
      }
    },
    async fillValue(place,placeID){
    // console.log(placeID);
      this.showZipAutoComplete = false;
      this.zipSearch = place;
      const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/` + placeID + `.json?types=postcode,address,locality,neighborhood,place&language=en&limit=8&autocomplete=false&proximity=-74.70850,40.78375&access_token=pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2s2dG11bXhvMDB0eTNycWN0NWR6bGxmMiJ9.rAfZTp56zepoSSpMs0I8XQ`);
      const geoPlace = await response.json();
    },

    async getAvailableTaxonomies() {
    const response = await fetch(`/wp-json/wp/v2/industry?per_page=100`);
    const data = await response.json();
    const specialties = data.map(
        item => [item.name, item.slug]
    );
    this.filters = specialties;
    this.taxos = data;
    },
    //get the closest brokers;
    async getBrokers(country){
        this.showError = false;
        this.brokerLoader = true;
        //Geolocate the search
        this.triggerGTMbrokerSearch();
        var searchZip = this.zipSearch;
        if(searchZip === '') {
            this.showError = true;
        }
        const mapbox = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/` + searchZip + `.json?types=postcode,address,locality,neighborhood,place&limit=8&language=en&autocomplete=false&proximity=-74.70850,40.78375${(country ? `&country=` + country : '')}&access_token=pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2s2dG11bXhvMDB0eTNycWN0NWR6bGxmMiJ9.rAfZTp56zepoSSpMs0I8XQ`);
        const geo = await mapbox.json();
        //check the distance selected and other filters
        const dist = this.distance;
        var taxos = this.specialties;
        var cbi = this.cbi;

        //set the lat, lng of search
        const lat = geo.features[0].center[1];
        const lng = geo.features[0].center[0];

        //call brokers
        let response = await fetch(`/wp-json/brokers/geo?lat=${lat}&lng=${lng}&miles=${dist}&specialties=${taxos}&cbi=${cbi}`);
        // console.log(response);

        const brokers = await response.json();
        //show error if no results
        // console.log(brokers);
        var that = this;
        if (brokers.features === undefined || brokers.features.length == 0) {
        //clean results in case of a previous successful search
        window.scrollTo(0, 0);
        this.brokerLoader = false;
        this.showResults = false;
        this.showErrorMessage = true;
        } else {
        window.scrollTo(0, 0);
        //in case of previous error, clean it
        this.brokerLoader = false;
        this.showErrorMessage = false;
        this.showResults = true;
        this.searchVisible = false;
        this.setMap(brokers);
        } //Close else

    },
    setMap(brokers){
        //wait until map div is available because of the transition
        setTimeout(() => {
            //create the map and center it
            mapboxgl.accessToken = 'pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2s2dG11bXhvMDB0eTNycWN0NWR6bGxmMiJ9.rAfZTp56zepoSSpMs0I8XQ';
            this.map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/light-v10',
            center: [-96, 37.8],
            zoom: 2,
            pitch: 15,
            bearing: 25
            // animate: false
            });
            //disable wheel zoom and add controllers
            this.map.scrollZoom.disable();
            this.map.addControl(new mapboxgl.NavigationControl());

            var bounds = new mapboxgl.LngLatBounds();
            this.setMarkers(brokers, bounds);
        }, 400);
    },
    setMarkers(brokers, bounds){
        var that = this;
        brokersListArray = [];
        this.map.on('load', function () {
        // add the source first
        this.addSource('brokers', {
            type: 'geojson',
            data: brokers,
        });
        //define the map object for inner functions
        let createdMap = this;
        //define the empty brokers list array
        //add the pins
        brokers.features.forEach(function(marker, i) {
            //get the broker details for the popup
            var props = marker.geometry.properties;
            //get the portrait
            var portrait = props.portrait;
            //create the marker
            var el = document.createElement('div');
            el.className = 'marker';
            el.innerHTML = '<span><b>' + (i + 1) + '</b></span>'
            // make a marker for each feature and add it to the map
            new mapboxgl.Marker(el)
            .setLngLat(marker.geometry.coordinates)
            .setPopup(new mapboxgl.Popup({
                offset: 25
            }) // add popups
            .setHTML(`<div class="brPop"><a href="${props.url}" target="_blank"><h3>` + props.name + `</h3></a><p>${props.company}</p><small>${(props.city[0]) ? props.city : '' }, ${props.state} ${props.zip}</small><br><a href="${props.url}" target="_blank">Visit Profile</a></div>`))
            .addTo(createdMap);
            bounds.extend(marker.geometry.coordinates);
            //create the list
            //format names (for brokers with all caps)
            this.brokersListArray.push({
                'id' : (i + 1),
                'distance' : props.distance,
                'portrait' : portrait,
                'name' : props.name,
                'cbi' : (props.cbi === '1' || props.cbi === true ? true : false),
                'mami' : (props.mami === '1' || props.mami === true ? true : false),
                'mcbi' : (props.master_cbi === '1' || props.master_cbi === true ? true : false),
                'company' : props.company,
                'city' : props.city,
                'state' : props.state,
                'zip' : props.zip,
                'url' : props.url,
                'coords' : marker.geometry.coordinates
            });
        });
        
        //if there's only one result, center the map on that pin
        if(brokers.features.length == 1){
            createdMap.flyTo({
                center: brokers.features[0].geometry.coordinates,
                zoom: 14,
                speed: 1,
                pitch: 45,
                bearing: -20
            });
        } else {
            //change padding to prevent animation fail
            const mq = window.matchMedia("(min-width: 1280px)");
            if (mq.matches) {
                // window width is at least 1280px
                var pad = {
                    top: 80,
                    bottom: 140,
                    left: 280,
                    right: 280
                }
            } else {
                // window width is less than 1280px
                var pad = {
                    top: 50,
                    bottom: 50,
                    left: 50,
                    right: 50
                }
            }
            createdMap.fitBounds(bounds,{
                padding: pad,
                speed: 1,
                pitch: 45,
                bearing: -20,
                antialias: true
            });
        }                    
        });
        if(this.brokerList.length != undefined){
        this.brokerList = brokersListArray;
        this.showList = 'true';
        }
    },
    // triggerGTMeventLocSearch(search, taxos, cbi){
    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push({
    //         'event': 'brokerSearch',
    //         'brokerSType': 'Closest and Specialty ' ,
    //         'brokerSTerm': search ,
    //         'brokerSSpecialty': taxos ,
    //         'brokerSCertified': cbi
    //     });
    // },
    //Fill brokers for autocomplete
    async fillBrokers() {
        // Check minimum character requirement
        if (this.nameSearch.length < 3) {
            this.autoCompleteMsg = '<span style="color: #d65a45;">Please enter at least 3 characters to search</span><br><small style="font-size: 0.875rem; opacity: 0.8;">Tip: More characters = better results. Try entering a full word.</small>';
            this.showAutoComplete = false;
            return;
        }

        this.showTitle = false;
        this.autoCompleteMsg = 'We are fetching the advisors, please wait'

        const brokersCall = await fetch(`https://www.ibba.org/wp-json/brokers/search?query=${this.nameSearch}`);
        const brokersData = await brokersCall.json();
        const firstArray = [];
        this.fullNames = brokersData.posts.forEach(function(item) {
            const fullName = item.first_name + ' ' +item.last_name;
            const company = item.company;
            firstArray.push({"fullNameAndComp": fullName + ' ' + company, "fullName": fullName, "city": item.city[0], "state": item.state[0], "country" : item.country[0], "company": item.company[0], "permalink":item.permalink, "address" : item.address[0], "address2": item.address_2[0], "phone": item.phone[0], "email": item.email[0]});
        });   
        this.fullNames = firstArray;
        // Push member search event if nameSearch is not empty
        if (this.nameSearch && this.nameSearch.trim() !== '') {
          this.pushMemberSearchDataLayer(this.nameSearch);
        }
        this.handleBrokerSearch();
    },
    async handleBrokerSearch() {
        this.showAutoComplete = true;
        this.autoCompleteMsg = '<img src="/wp-content/plugins/ibba-brokers/public/img/loader.gif" width="20"> We are fetching the brokers, please wait'
        // this.results = this.fullNames.filter(
        //    el => String(el.fullNameAndComp).toLowerCase().indexOf(this.nameSearch.toLowerCase()) !== -1
        // );
        if (this.fullNames.length === 0){
            this.autoCompleteMsg = 'There are no results for your search';
        } else if (this.fullNames.length > 0){
            this.autoCompleteMsg = '';
            this.showTitle = true;
        } else {
            this.autoCompleteMsg = '<img src="/wp-content/plugins/ibba-brokers/public/img/loader.gif" width="20"> We are fetching the brokers, please wait';
        }
    },
    // async autocomplete() {
    //     this.showAutoComplete = true;
    //     this.autoCompleteMsg = '<img src="/wp-content/plugins/ibba-brokers/public/img/loader.gif" width="20"> We are fetching the brokers, please wait'
    //     this.results = this.fullNames.filter(
    //        el => String(el[0]).toLowerCase().indexOf(this.nameSearch.toLowerCase()) !== -1
           
    //     );
    //     if (this.results.length === 0){
    //         this.autoCompleteMsg = 'There are no results for your search';
    //     } else if (this.results.length > 0){
    //         this.autoCompleteMsg = '';
    //         this.showTitle = true;
    //     } else {
    //         this.autoCompleteMsg = '<img src="/wp-content/plugins/ibba-brokers/public/img/loader.gif" width="20"> We are fetching the brokers, please wait';
    //     }
    // },
    triggerGTMbrokerSearch(){
        const urlParams = new URLSearchParams(window.location.search);
        
        // Get search context from URL parameters
        const searchContext = urlParams.get('searchContext') || 'advanced';
        const searchType = urlParams.get('searchType') || 'advanced';
        
        // Map context to label
        const contextMap = {
            'home': 'Home search',
            'header': 'Header search',
            'state': 'State search',
            'canada': 'Canada search',
            'industry': 'Industry search',
            'advanced': 'Advanced search',
            'member': 'Member search'
        };
        
        const searchLabel = contextMap[searchContext] || 'Advanced search';
        
        // Format specialties to use display names instead of slugs
        const formattedSpecialties = this.specialties.map(slug => {
            const specialty = this.filters.find(filter => filter[1] === slug);
            return specialty ? specialty[0] : slug;
        });
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'search',
            searchType: searchType,
            searchLabel: searchLabel,
            searchTerm: this.zipSearch || '',
            searchSpecialties: formattedSpecialties.length ? formattedSpecialties : [],
            searchMiles: this.distance ? this.distance + ' miles' : '',
            searchCertified: this.cbi ? 'Yes' : 'No'
        });
    },
    flyToPlace (coords, props){
        this.map.setBearing(-20);
        this.map.setPitch(45);
        this.map.flyTo({
            center: coords,
            zoom: 12,
            pitch: 15,
            bearing: 0
        });
        var popUps = document.getElementsByClassName('mapboxgl-popup');
        // Check if there is already a popup on the map and if so, remove it
        if (popUps[0]) popUps[0].remove();

        var popup = new mapboxgl.Popup({ closeOnClick: true, offset: 50 })
            .setLngLat(coords)
            .setHTML(`<div class="brPop"><a href="${props.url}" target="_blank"><h3>` + props.name + `</h3></a><p>${props.company}</p><small>${(props.city[0]) ? props.city[0].toUpperCase() + props.city.slice(1) : ''}, ${props.state} ${props.zip}</small><br><a href="${props.url}" target="_blank">Visit Profile</a></div>`)
            .addTo(this.map);
    },
    getPostParameter(parameterName) {
        var result = null,
        tmp = [];
        location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
        return result;
    },
    async getStates() {
        const statesCall = await fetch(`/wp-json/wp/v2/state?per_page=100`);
        const states = await statesCall.json();
        this.states = states;
    },
    async getCanadianStates() {
        const castatesCall = await fetch(`/wp-json/wp/v2/canadian-state?per_page=100`);
        const castates = await castatesCall.json();
        this.cstates = castates;
    },
    trackSpecialtySelection(specialtyName) {
      console.log('Specialty selected:', specialtyName);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "specialtySelected",
        specialtyItem: specialtyName
      });
    },
    pushMemberSearchDataLayer(searchTerm) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'search',
        searchType: 'simple',
        searchLabel: 'Member search',
        searchTerm: searchTerm,
        searchSpecialties: '',
        searchMiles: '',
        searchCertified: ''
      });
    },
  },
  mounted() {
    this.getAvailableTaxonomies();
    // this.fillBrokers();
    this.getStates();
    this.getCanadianStates();
    var postVars = window.location.search.substr(1);
    if(postVars != '' && this.getPostParameter('place')){
        var place = this.getPostParameter('place');
        var getdistance = this.getPostParameter('distance');
        var getcbi = this.getPostParameter('cbi');
        var countries = 'us,ca';
        if(getdistance){
            this.distance = getdistance;
        }
        if(getcbi){
            this.cbi = true;
        }
        this.zipSearch = place;
        this.getBrokers(countries);
    }
  },
  filters: {
  }
});
</script>